import { actionTypes } from '~/constants';

const initialState = {
    list: [],
    detail: null,
    is_loaded: false
};

export default (state = initialState, action) => {
    let index;
    switch(action.type) {
        case actionTypes.REPORTS_CLEAR_DETAIL:
            return {
                ...state,
                detail: null,
                is_loaded: true,
            }
        case actionTypes.REPORTS_FETCH_ALL:
            return {
                ...state,
                is_loaded: false,
            }
        case actionTypes.REPORTS_FETCH_ALL_SUCCESS:
            return {
                ...state,
                list: action.reports,
                is_loaded: true
            }
        case actionTypes.REPORTS_FETCH_ALL_ERROR:
            return {
                ...state,
                list: [],
                is_loaded: false
            }
        case actionTypes.REPORTS_FETCH_ONE:
            return {
                ...state,
                is_loaded: false,
            }
        case actionTypes.REPORTS_FETCH_ONE_SUCCESS:
            index = state.list.findIndex(r=>r._id===action.detail._id)
            return {
                ...state,
                detail: action.detail,
                list: [
                    ...state.list.slice(0, index),
                    action.detail,
                    ...state.list.slice(index + 1)
                ],
                is_loaded: true
            }
        case actionTypes.REPORTS_FETCH_ONE_ERROR:
            return {
                ...state,
                detail: null,
                is_loaded: false
            }
        case actionTypes.REPORTS_UPDATE_ONE:
            return {
                ...state,
            }
        case actionTypes.REPORTS_UPDATE_ONE_SUCCESS:
            index = state.list.findIndex(r=>r._id===action.report._id)
            return {
                ...state,
                detail: action.report,
                list: [
                    ...state.list.slice(0, index),
                    action.report,
                    ...state.list.slice(index + 1)
                ],
            }
        case actionTypes.REPORTS_UPDATE_ONE_ERROR:
            return {
                ...state,
            }
        default:
            return state;
    }
}
